import styled from 'styled-components';
import { useRouter } from 'next/router';
import { LOCALES } from 'localization/constants/configEnums';
import { slugify } from 'shared/utils/consumerSearchSlugify';

interface ISitemapData {
  title: string;
  children?: ISitemapData[];
  type?: string;
  link?: string;
}

const normalizeURL = (str: string, locale: string) => {
  let normalizedURL;
  let lastPath: string;

  // We only want to normalize the last portion of the path
  normalizedURL = str.split('/');
  lastPath = normalizedURL.pop();
  lastPath = slugify(lastPath);

  // Attaching normalized last path and turning to full string path
  normalizedURL.push(lastPath);
  normalizedURL = normalizedURL.join('/');
  if (locale !== LOCALES.enUS) {
    normalizedURL = `/${locale}${normalizedURL as string}`;
  }
  return normalizedURL;
};

export const RenderAndRecurseChildren = ({ data }: { data: ISitemapData[] }) => {
  const { locale } = useRouter();
  return (
    <ul>
      {data?.map(({ title, link, children }) => (
        <li key={`key-${title}`}>
          <RenderAndRecurseChildren.A href={normalizeURL(link, locale) || '#'}>
            {title}
          </RenderAndRecurseChildren.A>
          {children && <RenderAndRecurseChildren data={children} />}
        </li>
      ))}
    </ul>
  );
};

// Adding some spacing to comply with Google's accessibility tap targets.
RenderAndRecurseChildren.A = styled.a`
  margin: 8px 0;
  display: block;
`;
